// import toastStore from '@/stores/toast-store.js';
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import firebase from '@/vcs/_shared/firebase.js'

import IsChromeDesktop from '@/mixins/is-chrome-desktop.js'
import IsChromeAndroid from '@/mixins/is-chrome-android.js'
import IsFirefoxDesktop from '@/mixins/is-firefox-desktop.js'
import UpdateUserActivity from '@/mixins/update-user-activity.js'
import SendDeviceToken from '@/mixins/send-device-token.js'

export default {
  name: 'NotificationPromptModalForChromeAndroidDesktop',
  extends: BaseModal,
  mixins: [IsChromeDesktop, IsChromeAndroid, IsFirefoxDesktop, UpdateUserActivity, SendDeviceToken],
  data: function () {
    return {}
  },
  methods: {
    async flowFCM() {
      let platform = ''
      if (this.isChromeAndroid) {
        platform = 'chrome-android'
      } else if (this.isChromeDesktop) {
        platform = 'chrome-desktop'
      } else if (this.isFirefoxDesktop) {
        platform = 'firefox-desktop'
      }

      try {
        const messaging = firebase.messaging()
        await messaging.requestPermission()
        const token = await messaging.getToken()

        this.notificationAllowance(platform, true)
        this.sendDeviceToken(token, 'web')
        setTimeout(() => {
          this.close(false)
        }, 0)
      } catch (error) {
        // PUSH NOTIFICATIONS NOT ALLOWED
        console.error('---- flowFCM error 1, no token ----', error)
        this.notificationAllowance(platform, false)
        setTimeout(() => {
          this.close(false)
        }, 0)
      }
    },

    notificationAllowance(platform, value) {
      // Registered when user first time interact with native notification prompt
      this.updateUserActivity(platform, 'push_notification_allowance', value)
      localStorage.setItem('push_notifications_allowed', value)
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
